// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { triangle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-triangle': IconTriangle;
    }
}

/**
 * The icon component for the 'triangle' icon
 */
export class IconTriangle extends IconSvg {
    public constructor() {
        super(triangle16X16);
    }
}

registerIconSvg('icon-triangle', IconTriangle);
export const iconTriangleTag = 'nimble-icon-triangle';
